// ACTION-ORIENTED DYNAMIC UI (A2UI v2) — a PLANNING / build-in-public episode.
// ~4:40 @ 30fps. Cold Compute / Neon kit.
//
// The shift: an agent that SHOWS read-only data → an agent that BUILDS interactive
// UI carrying inputs, controls, and actions. This episode covers the PLANNING and
// phased implementation, with every phase's status labelled ON SCREEN.
//
// HONESTY (mandatory, series core rule): P0 = SHIPPED (commit 87a2d85a, emit_widget
// first-class plan field); the read-only A2UI foundation (11-type catalog +
// fail-closed validator + renderer + signed-token embed) = SHIPPED; P1 action spine
// = BUILT BEHIND A FLAG (A2UI_ACTIONS_ENABLED default OFF, dormant); P2–P5 = ROADMAP.
// Every on-screen path/number/claim traces to the design spec or real code — see the
// metadata.md GROUNDING NOTE.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @ 30fps; contiguous, sized to
// FIT each scene's captions (last caption + a readable tail) — no dead air. With
// sticky captions the last line persists to scene end.
export const SCENE = {
  // 01 — the shift: agents that SHOW data → agents that BUILD interactive UI.
  hook: { start: 0, duration: 900 }, //               0:00–0:30
  // 02 — the landscape verdict: keep / borrow / adopt / avoid.
  landscape: { start: 900, duration: 1260 }, //       0:30–1:12
  // 03 — the architecture: one descriptor → 3 surfaces → ONE action spine → 4 transports.
  architecture: { start: 2160, duration: 1230 }, //   1:12–1:53
  // 04 — the action spine + safety: renderer EMITS never executes; frozen registry; tiered confirm.
  spine: { start: 3390, duration: 1500 }, //          1:53–2:43
  // 05 — the phasing: P0 SHIPPED · P1 BEHIND A FLAG · P2–P5 ROADMAP, each labelled on screen.
  phasing: { start: 4890, duration: 1560 }, //        2:43–3:35
  // 06 — close: "measure, ground, gate" — the build-in-public throughline.
  close: { start: 6450, duration: 750 }, //           3:35–4:00
} as const;

// 7200 frames = 240s = 4:00 @ 30fps.
export const TOTAL_DURATION =
  SCENE.hook.duration +
  SCENE.landscape.duration +
  SCENE.architecture.duration +
  SCENE.spine.duration +
  SCENE.phasing.duration +
  SCENE.close.duration; // = 7200

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
